import { createApp } from 'vue/dist/vue.esm-bundler.js'
import draggable from 'vuedraggable'

{
  const appConfig = {
    components: {
      draggable
    },
    data(){
      return {
        loading: true,
        categories: [],
      }
    },
    mounted(){
      this.fetchJudgeDashboard()
    },
    methods: {
      hasOverallWinnerNominee(){
        let hasWinner = false
        this.categories.forEach(cat => {
          if(cat.id == -99){
            hasWinner = cat.nominees.length > 0
          }
        })
        return hasWinner
      },
      fetchJudgeDashboard(){
        this.loading = true
        window.coolHelperFunctions.coolAjax({
          action: "fetch_judge_dashboard"
        }, json => {
          this.categories = json.dashboard_data
          this.updateVoteOrder()
        }, err => {
          alert(err)
        })
      },
      removeAsFinalist(nomineeId){
        this.loading = true
        window.coolHelperFunctions.coolAjax({
          action: "judge_remove_as_finalist",
          nominee_id: nomineeId
        }, json => {
          this.fetchJudgeDashboard()
        }, err => {
          alert(err)
        })
      },
      setAsOverallWinner(nomineeId){
        this.loading = true
        window.coolHelperFunctions.coolAjax({
          action: "judge_set_as_overall_winner",
          nominee_id: nomineeId
        }, json => {
          this.fetchJudgeDashboard()
        }, err => {
          alert(err)
        })
      },
      removeAsOverallWinner(nomineeId){
        this.loading = true
        window.coolHelperFunctions.coolAjax({
          action: "judge_remove_as_overall_winner",
          nominee_id: nomineeId
        }, json => {
          this.fetchJudgeDashboard()
        }, err => {
          alert(err)
        })
      },
      updateVoteOrder(){
        this.loading = true
        window.coolHelperFunctions.coolAjax({
          action: "update_judge_votes",
          categories: this.categories.map(c => {
            return {
              id: c.id,
              nominees: c.nominees.map(n => n.id)
            }
          })
        }, json => {
          this.loading = false
        }, err => {
          alert(err)
        })
      }
    }
  }

  function initApp(){
    const els = document.querySelectorAll('.judge-app')
    if(els.length){
      els.forEach(el => {
        const app = createApp(appConfig)
        app.mount(el)
      })
    }
  }

  initApp()
}
